export const frontConstants = {
  GET_ALLDEAL_REQUEST: "GET_ALLDEAL_REQUEST",
  GET_ALLDEAL_SUCCESS: "GET_ALLDEAL_SUCCESS",
  GET_ALLDEAL_FAILURE: "GET_ALLDEAL_FAILURE",
  GET_MENU_REQUEST: "GET_MENU_REQUEST",
  GET_MENU_SUCCESS: "GET_MENU_SUCCESS",
  GET_MENU_FAILURE: "GET_MENU_FAILURE",
  GET_TOPDEAL_REQUEST: "GET_TOPDEAL_REQUEST",
  GET_TOPDEAL_SUCCESS: "GET_TOPDEAL_SUCCESS",
  GET_TOPDEAL_FAILURE: "GET_TOPDEAL_FAILURE",
  GET_CURRENTDEAL_REQUEST: "GET_CURRENTDEAL_REQUEST",
  GET_CURRENTDEAL_SUCCESS: "GET_CURRENTDEAL_SUCCESS",
  GET_CURRENTDEAL_FAILURE: "GET_CURRENTDEAL_FAILURE",
  GET_MERCHANTDIRECTORYLIST_REQUEST: "GET_MERCHANTDIRECTORYLIST_REQUEST",
  GET_MERCHANTDIRECTORYLIST_SUCCESS: "GET_MERCHANTDIRECTORYLIST_SUCCESS",
  GET_MERCHANTDIRECTORYLIST_FAILURE: "GET_MERCHANTDIRECTORYLIST_FAILURE",
  GET_UPCOMINGDEAL_REQUEST: "GET_UPCOMINGDEAL_REQUEST",
  GET_UPCOMINGDEAL_SUCCESS: "GET_UPCOMINGDEAL_SUCCESS",
  GET_UPCOMINGDEAL_FAILURE: "GET_UPCOMINGDEAL_FAILURE",
  GET_DEALDETAIL_REQUEST: "GET_DEALDETAIL_REQUEST",
  GET_DEALDETAIL_SUCCESS: "GET_DEALDETAIL_SUCCESS",
  GET_DEALDETAIL_FAILURE: "GET_DEALDETAIL_FAILURE",
  GET_ADDTOCART_REQUEST: "GET_ADDTOCART_REQUEST",
  GET_ADDTOCART_SUCCESS: "GET_ADDTOCART_SUCCESS",
  GET_ADDTOCART_FAILURE: "GET_ADDTOCART_FAILURE",

  GET_CHECKUSERKEY_REQUEST: "GET_CHECKUSERKEY_REQUEST",
  GET_CHECKUSERKEY_SUCCESS: "GET_CHECKUSERKEY_SUCCESS",
  GET_CHECKUSERKEY_FAILURE: "GET_CHECKUSERKEY_FAILURE",

  GET_CARTDETAIL_REQUEST: "GET_CARTDETAIL_REQUEST",
  GET_CARTDETAIL_SUCCESS: "GET_CARTDETAIL_SUCCESS",
  GET_CARTDETAIL_FAILURE: "GET_CARTDETAIL_FAILURE",

  GET_CARTQUANTITY_REQUEST: "GET_CARTQUANTITY_REQUEST",
  GET_CARTQUANTITY_SUCCESS: "GET_CARTQUANTITY_SUCCESS",
  GET_CARTQUANTITY_FAILURE: "GET_CARTQUANTITY_FAILURE",

  GET_CARTUPDATE_REQUEST: "GET_CARTUPDATE_REQUEST",
  GET_CARTUPDATE_SUCCESS: "GET_CARTUPDATE_SUCCESS",
  GET_CARTUPDATE_FAILURE: "GET_CARTUPDATE_FAILURE",
  GET_REMOVEITEM_REQUEST: "GET_REMOVEITEM_REQUEST",
  GET_REMOVEITEM_SUCCESS: "GET_REMOVEITEM_SUCCESS",
  GET_REMOVEITEM_FAILURE: "GET_REMOVEITEM_FAILURE",
  GET_CHECKOUT_REQUEST: "GET_CHECKOUT_REQUEST",
  GET_CHECKOUT_SUCCESS: "GET_CHECKOUT_SUCCESS",
  GET_CHECKOUT_FAILURE: "GET_CHECKOUT_FAILURE",
  GET_APPLYPROMO_REQUEST: "GET_APPLYPROMO_REQUEST",
  GET_APPLYPROMO_SUCCESS: "GET_APPLYPROMO_SUCCESS",
  GET_APPLYPROMO_FAILURE: "GET_APPLYPROMO_FAILURE",
  GET_REGISTER_REQUEST: "GET_REGISTER_REQUEST",
  GET_REGISTER_SUCCESS: "GET_REGISTER_SUCCESS",
  GET_REGISTER_FAILURE: "GET_REGISTER_FAILURE",
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",
  GET_VOUCHERLIST_REQUEST: "GET_VOUCHERLIST_REQUEST",
  GET_VOUCHERLIST_SUCCESS: "GET_VOUCHERLIST_SUCCESS",
  GET_VOUCHERLIST_FAILURE: "GET_VOUCHERLIST_FAILURE",
  GET_VOUCHERLISTARCHIVE_REQUEST: "GET_VOUCHERLISTARCHIVE_REQUEST",
  GET_VOUCHERLISTARCHIVE_SUCCESS: "GET_VOUCHERLISTARCHIVE_SUCCESS",
  GET_VOUCHERLISTARCHIVE_FAILURE: "GET_VOUCHERLISTARCHIVE_FAILURE",
  GET_ORDERLIST_REQUEST: "GET_ORDERLIST_REQUEST",
  GET_ORDERLIST_SUCCESS: "GET_ORDERLIST_SUCCESS",
  GET_ORDERLIST_FAILURE: "GET_ORDERLIST_FAILURE",
  GET_CUSTOMER_REQUEST: "GET_CUSTOMER_REQUEST",
  GET_CUSTOMER_SUCCESS: "GET_CUSTOMER_SUCCESS",
  GET_CUSTOMER_FAILURE: "GET_CUSTOMER_FAILURE",
  UPDATE_PROFILE_REQUEST: "UPDATE_PROFILE_REQUEST",
  UPDATE_PROFILE_SUCCESS: "UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "UPDATE_PROFILE_FAILURE",
  UPDATE_PASSWORD_REQUEST: "UPDATE_PASSWORD_REQUEST",
  UPDATE_PASSWORD_SUCCESS: "UPDATE_PASSWORD_SUCCESS",
  UPDATE_PASSWORD_FAILURE: "UPDATE_PASSWORD_FAILURE",
  PRINT_VOUCHER_REQUEST: "PRINT_VOUCHER_REQUEST",
  PRINT_VOUCHER_SUCCESS: "PRINT_VOUCHER_SUCCESS",
  PRINT_VOUCHER_FAILURE: "PRINT_VOUCHER_FAILURE",
  PRINT_AVOUCHER_REQUEST: "PRINT_AVOUCHER_REQUEST",
  PRINT_AVOUCHER_SUCCESS: "PRINT_AVOUCHER_SUCCESS",
  PRINT_AVOUCHER_FAILURE: "PRINT_VOUCHER_FAILURE",
  GET_CATDEAL_REQUEST: "GET_CATDEAL_REQUEST",
  GET_CATDEAL_SUCCESS: "GET_CATDEAL_SUCCESS",
  GET_CATDEAL_FAILURE: "GET_CATDEAL_FAILURE",
  GET_STORECREDIT_REQUEST: "GET_STORECREDIT_REQUEST",
  GET_STORECREDIT_SUCCESS: "GET_STORECREDIT_SUCCESS",
  GET_STORECREDIT_FAILURE: "GET_STORECREDIT_FAILURE",
  GET_COUPON_REQUEST: "GET_COUPON_REQUEST",
  GET_COUPON_SUCCESS: "GET_COUPON_SUCCESS",
  GET_COUPON_FAILURE: "GET_COUPON_FAILURE",
  GET_SETATTRIBUTE_REQUEST: "GET_SETATTRIBUTE_REQUEST",
  GET_SETATTRIBUTE_SUCCESS: "GET_SETATTRIBUTE_SUCCESS",
  GET_SETATTRIBUTE_FAILURE: "GET_SETATTRIBUTE_FAILURE",
  POST_SUBSCRIBE_REQUEST: "POST_SUBSCRIBE_REQUEST",
  POST_SUBSCRIBE_SUCCESS: "POST_SUBSCRIBE_SUCCESS",
  POST_SUBSCRIBE_FAILURE: "POST_SUBSCRIBE_FAILURE",
  POST_AUTH_CITY_PWD_REQUEST: "POST_AUTH_CITY_PWD_REQUEST",
  POST_AUTH_CITY_PWD_SUCCESS: "POST_AUTH_CITY_PWD_SUCCESS",
  POST_AUTH_CITY_PWD_FAILURE: "POST_AUTH_CITY_PWD_FAILURE",
  CHECK_USER_DEAL_REQUEST: "CHECK_USER_DEAL_REQUEST",
  CHECK_USER_DEAL_SUCCESS: "CHECK_USER_DEAL_SUCCESS",
  CHECK_USER_DEAL_FAILURE: "CHECK_USER_DEAL_FAILURE",
  GET_CITY_REQUEST: "GET_CITY_REQUEST",
  GET_CITY_SUCCESS: "GET_CITY_SUCCESS",
  GET_CITY_FAILURE: "GET_CITY_FAILURE",
  GET_WIDGET_REQUEST: "GET_WIDGET_REQUEST",
  GET_WIDGET_SUCCESS: "GET_WIDGET_SUCCESS",
  GET_WIDGET_FAILURE: "GET_WIDGET_FAILURE",
  POST_PARTNER_REQUEST: "POST_PARTNER_REQUEST",
  POST_PARTNER_SUCCESS: "POST_PARTNER_SUCCESS",
  POST_PARTNER_FAILURE: "POST_PARTNER_FAILURE",
  PARTNER_PERMISSION_REQUEST: "PARTNER_PERMISSION_REQUEST",
  PARTNER_PERMISSION_SUCCESS: "PARTNER_PERMISSION_SUCCESS",
  PARTNER_PERMISSION_FAILURE: "PARTNER_PERMISSION_FAILURE",
  POST_STATUS_REQUEST: "POST_STATUS_REQUEST",
  POST_STATUS_SUCCESS: "POST_STATUS_SUCCESS",
  POST_STATUS_FAILURE: "POST_STATUS_FAILURE",
  POST_CHARITYLIST_REQUEST: "POST_CHARITYLIST_REQUEST",
  POST_CHARITYLIST_SUCCESS: "POST_CHARITYLIST_SUCCESS",
  POST_CHARITYLIST_FAILURE: "POST_CHARITYLIST_FAILURE",
  REMOVE_ROMO_REQUEST: "REMOVE_ROMO_REQUEST",
  REMOVE_ROMO_SUCCESS: "REMOVE_ROMO_SUCCESS",
  REMOVE_ROMO_FAILURE: "REMOVE_ROMO_FAILURE",
  GET_COUPONLIST_REQUEST: "GET_COUPONLIST_REQUEST",
  GET_COUPONLIST_SUCCESS: "GET_COUPONLIST_SUCCESS",
  GET_COUPONLIST_FAILURE: "GET_COUPONLIST_FAILURE",
  GET_REFFERALS_REQUEST: "GET_REFFERALS_REQUEST",
  GET_REFFERALS_SUCCESS: "GET_REFFERALS_SUCCESS",
  GET_REFFERALS_FAILURE: "GET_REFFERALS_FAILURE",
  DELETE_CARD_REQUEST: "DELETE_CARD_REQUEST",
  DELETE_CARD_SUCCESS: "DELETE_CARD_SUCCESS",
  DELETE_CARD_FAILURE: "DELETE_CARD_FAILURE",
  GET_ALLCITY_REQUEST: "GET_ALLCITY_REQUEST",
  GET_ALLCITY_SUCCESS: "GET_ALLCITY_SUCCESS",
  GET_ALLCITY_FAILURE: "GET_ALLCITY_FAILURE",
  GET_LANGLIST_REQUEST: "GET_LANGLIST_REQUEST",
  GET_LANGLIST_SUCCESS: "GET_LANGLIST_SUCCESS",
  GET_LANGLIST_FAILURE: "GET_LANGLIST_FAILURE",
  GET_MAILEDLIST_REQUEST: "GET_MAILEDLIST_REQUEST",
  GET_MAILEDLIST_SUCCESS: "GET_MAILEDLIST_SUCCESS",
  GET_MAILEDLIST_FAILURE: "GET_MAILEDLIST_FAILURE",
  GET_GIFTLIST_REQUEST: "GET_GIFTLIST_REQUEST",
  GET_GIFTLIST_SUCCESS: "GET_GIFTLIST_SUCCESS",
  GET_GIFTLIST_FAILURE: "GET_GIFTLIST_FAILURE",
  GET_GENERATEDLIST_REQUEST: "GET_GENERATEDLIST_REQUEST",
  GET_GENERATEDLIST_SUCCESS: "GET_GENERATEDLIST_SUCCESS",
  GET_GENERATEDLIST_FAILURE: "GET_GENERATEDLIST_FAILURE",
  GET_SUBSCRIBERDETAIL_REQUEST: "GET_SUBSCRIBERDETAIL_REQUEST",
  GET_SUBSCRIBERDETAIL_SUCCESS: "GET_SUBSCRIBERDETAIL_SUCCESS",
  GET_SUBSCRIBERDETAIL_FAILURE: "GET_SUBSCRIBERDETAIL_FAILURE",
  GET_TAX_REQUEST: "GET_TAX_REQUEST",
  GET_TAX_SUCCESS: "GET_TAX_SUCCESS",
  GET_TAX_FAILURE: "GET_TAX_FAILURE",
  GET_SEARCHSTATE_REQUEST: "GET_SEARCHSTATE_REQUEST",
  GET_SEARCHSTATE_SUCCESS: "GET_SEARCHSTATE_SUCCESS",
  GET_SEARCHSTATE_FAILURE: "GET_SEARCHSTATE_FAILURE",

  CHECKGUESTEMAIL_REQUEST: "CHECKGUESTEMAIL_REQUEST",
  CHECKGUESTEMAIL_SUCCESS: "CHECKGUESTEMAIL_SUCCESS",
  CHECKGUESTEMAIL_FAILURE: "CHECKGUESTEMAIL_FAILURE",
  REGGUESTEMAIL_REQUEST: "REGGUESTEMAIL_REQUEST",
  REGGUESTEMAIL_SUCCESS: "REGGUESTEMAIL_SUCCESS",
  REGGUESTEMAIL_FAILURE: "REGGUESTEMAIL_FAILURE",
};



// WEBPACK FOOTER //
// ./src/app/redux/constants/frontConstants.js